import { render } from "./BrandyAgent.vue?vue&type=template&id=8c00b7d0"
import script from "./BrandyAgent.vue?vue&type=script&lang=js"
export * from "./BrandyAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__